import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span class="slex-badge"><!><span class="slex-badge-label"> </span></span>`);

export default function Badge($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function tone() {
		const raw = text($.get(p).tone ?? $.get(p).type ?? $.get(p).variant, "neutral").toLowerCase();

		if (raw === "danger" || raw === "error") return "destructive";
		if (raw === "muted" || raw === "neutral" || raw === "default") return "neutral";

		return raw;
	}

	var span = root();
	var node = $.child(span);

	{
		var consequent = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(p).icon;
				},
				className: 'slex-badge-icon'
			});
		};

		$.if(node, ($$render) => {
			if ($.get(p).icon) $$render(consequent);
		});
	}

	var span_1 = $.sibling(node);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(span);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(span, 'data-tone', $0);
			$.set_text(text_1, $1);
		},
		[
			() => tone(),
			() => text($.get(p).label ?? $.get(p).text ?? $.get(p).content ?? $$props.componentName)
		]
	);

	$.append($$anchor, span);
	$.pop();
}